import axios from 'axios';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addAlert } from '../../store/slices/alertReducer'
import * as taskApi from "../../api/tasks";
import { getActiveAssignments } from '../../helpers/task.helper';

export const completeTask = createAsyncThunk(
  "task/completeTask", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.completeTask(params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const stopTask = createAsyncThunk(
  "task/stopTask", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.stopTask(params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const claimTask = createAsyncThunk(
  "task/claimTask", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.claimTask(params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);


export const updateTask = createAsyncThunk(
  "task/updateTask", async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const { task } = state.tasks;
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      });
      return await taskApi.updateTask(task, params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const startTask = createAsyncThunk(
  "task/startTask", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.startTask(params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message, detail: error.detail });
    }
  }
);

export const pauseTask = createAsyncThunk(
  "task/pauseTask", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.pauseTask(params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const startTaskBulk = createAsyncThunk(
  "task/startTaskBulk", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.startTaskBulk(params.taskId, params.mAccounts, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message, detail: error.detail });
    }
  }
);

export const pauseTaskBulk = createAsyncThunk(
  "task/pauseTaskBulk", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.pauseTaskBulk(params.taskId, params.mAccounts, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const releaseTask = createAsyncThunk(
  "task/releaseTask", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.releaseTask(params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const releaseTaskBulk = createAsyncThunk(
  "task/releaseTaskBulk", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.releaseTaskBulk(params.taskId, params.mAccounts, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const assignTaskBulk = createAsyncThunk(
  "task/assignTaskBulk", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.assignTaskBulk(params.taskId, params.mAccounts, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const fetchTasks = createAsyncThunk(
  "task/fetchTasks", async (params, thunkAPI) => {
    try {
      const ascending = {
        'priority': false,
        'plannedStartDate': true,
        'taskOrder': true,
        'createdAt': true,
      }
      const filterkeys = {
        zone : 'postalCode',
        tasktype : 'taskType',
        assignedperson : 'assignee_maccount'
      }
      const state = thunkAPI.getState();
      const { page, pageSize, search, filters, order, ownerFilter } = state.tasks;
      const userLocation = state.userLocation;
      const { user: { userName } } = state.user;
      const apifilters = Object.keys(filters).map((key) => {
        if (typeof filters[key]  === "object" ) {
          if (key === "domain" || key === "tasktype") {
            return {
              field: filterkeys[key] || key,
              value: filters[key].label,
              operator: filters[key].operator || "="
            }
          }
          return {
            field: filterkeys[key] || key,
            value: filters[key].value,
            operator: filters[key].operator ||"="
          }
        }
        return {
          field: filterkeys[key] || key,
          value: filters[key],
          operator: "="
        }
      });
      apifilters.push({
        field: "publicationDate",
        operator: "<",
        value: new Date().toISOString(),
      })
      if (ownerFilter === "mijntaken") {
        apifilters.push({
          field:"status",
          operator:"=",
          value:"Assigned"
        });
        apifilters.push({
          field: "assignee_maccount",
          operator: "IN",
          value: userName.toUpperCase(),
        })
      }
      if (ownerFilter === "collegas") {
        apifilters.push({
          field:"status",
          operator:"=",
          value:"Assigned"
        });
        // Note: We don't filter by assignee_maccount here because we need to include
        // tasks where the user has a stopped assignment but someone else has an active one.
        // Client-side filtering will ensure only tasks with someone else's active assignment are shown.
      }
      if (ownerFilter === "niettoegekend") {
        apifilters.push({
          field: "status",
          operator: "=",
          value: "Created"
        });
        // Note: We don't filter on assignee_maccount here because it may still contain
        // stopped assignments. The status "Created" should be sufficient to indicate
        // the task is not assigned (all assignments are stopped).
      }
      let sortContext = [
        {
          path: 'active',
          ascending:false
        },
        {
          path: order,
          ascending: !!ascending[order],
        },
      ];
      if (order === "distance" && userLocation.loading === "loaded") {
        sortContext = [
          {
            path: 'active',
            ascending:false
          },
          {
            geo_distance:{
              location:{
                lat: userLocation.location.latitude,
                lon: userLocation.location.longitude,
              },
              order: 'asc',
              unit: 'km',
              mode: 'min',
              distance_type: 'arc',
              ignore_unmapped: false
            }
          },
        ];
      }
      const viewMode = state.viewMode;
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      // For list view, fetch all tasks at once to enable client-side pagination after filtering
      // For map view, fetch 3000 items
      const size = viewMode.name === "map" ? 3000 : 3000;
      const currentPage = 1; // Always fetch from page 1 when fetching all items
      const result = await taskApi.getTasks(currentPage, size, apifilters, search, sortContext, source);
      
      // Filter tasks based on active assignments
      if (result.tasks) {
        if (ownerFilter === "mijntaken") {
          // Filter out tasks from "mijn taken" where user only has stopped assignments
          // (i.e., task was reassigned to someone else) - these should appear in "collega's" instead
          result.tasks = result.tasks.filter((task) => {
            if (!task.taskAssignments) return false;
            const activeAssignments = getActiveAssignments(task.taskAssignments);
            // Only include tasks where the current user has an active assignment
            return activeAssignments.some(assignment => 
              assignment.todoAppUser.maccount.toLowerCase() === userName.toLowerCase()
            );
          });
        } else if (ownerFilter === "collegas") {
          // For "collega's", include tasks where someone else has an active assignment
          // BUT exclude tasks where the current user also has an active assignment
          result.tasks = result.tasks.filter((task) => {
            if (!task.taskAssignments) return false;
            const activeAssignments = getActiveAssignments(task.taskAssignments);
            const userHasActiveAssignment = activeAssignments.some(assignment => 
              assignment.todoAppUser.maccount.toLowerCase() === userName.toLowerCase()
            );
            const someoneElseHasActiveAssignment = activeAssignments.some(assignment => 
              assignment.todoAppUser.maccount.toLowerCase() !== userName.toLowerCase()
            );
            // Include tasks where someone else has an active assignment AND the user does NOT have an active assignment
            return someoneElseHasActiveAssignment && !userHasActiveAssignment;
          });
        }
      }
      
      return result;
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const fetchTask = createAsyncThunk(
  "task/fetchTask", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.getTask(params, source);
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const fetchTaskAttachments = createAsyncThunk(
  "task/fetchTaskAttachments", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.getTaskAttachments(params, source);
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const createTaskAttachment = createAsyncThunk(
  "task/createTaskAttachment", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.addTaskAttachments(params.taskId, params.assetId, source);
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const createTask = createAsyncThunk(
  "task/createTask", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.createTask(params, source);
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);
export const fetchTaskNotes = createAsyncThunk(
  "task/fetchTaskNotes", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.getTaskNotes(params, source);
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const addTaskNote = createAsyncThunk(
  "task/AddTaskNote", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await taskApi.addTaskNote(params.id, params.name, params.content, source);
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);
export const taskSlice = createSlice({
  name: 'task',
  initialState: {
    data: [],
    allFilteredTasks: [], // Store all filtered tasks for client-side pagination
    task: false,
    notes: false,
    page: 1,
    pages: 1,
    pageSize: 10,
    search: false,
    order: 'dueDate',
    ownerFilter: 'mijntaken',
    filters: {},
    totalValues: 1,
    selectedTask: false,
    attachments: [],
    files: [],
    currentRequestId: undefined,
    loading: null,
    notesLoading: null,
    createLoading: null,
    attachmentLoading: null,
  },
  reducers: {
    clear: (state, action) => {
      state.data = [];
    },
    setTask: (state, action) => {
      state.task = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.page = 1;
    },
    setSearch: (state, action) => {
      if(action.payload) {
        state.search = action.payload;
        state.page = 1;
      } else {
        state.search = false;
      }
    },
    selectTask: (state, action) => {
      state.selectedTask = action.payload;
    },
    setOwnerFilter: (state, action) => {
      state.ownerFilter = action.payload;
      state.page = 1;
    },
    setOrder: (state, action) => {
      state.order = action.payload;
      state.page = 1;
    },
    setPageSize: (state, action) => {
      state.pageSize = parseInt(action.payload, 10);
      // Recalculate pagination when page size changes
      const filteredTotal = state.allFilteredTasks.length;
      const totalPages = Math.ceil(filteredTotal / state.pageSize) || 1;
      state.pages = totalPages;
      // Reset to page 1 and recalculate displayed data
      state.page = 1;
      const startIndex = 0;
      const endIndex = state.pageSize;
      state.data = state.allFilteredTasks.slice(startIndex, endIndex);
      state.totalValues = filteredTotal || 1;
    },
    setPage: (state, action) => {
      state.page = action.payload;
      // Recalculate displayed data when page changes
      const startIndex = (state.page - 1) * state.pageSize;
      const endIndex = startIndex + state.pageSize;
      state.data = state.allFilteredTasks.slice(startIndex, endIndex);
    },
    setAttachmentLoading: (state, action) => {
      state.attachmentLoading = "loading";
    },
    resetAttachmentLoading: (state, action) => {
      state.attachmentLoading = null;
    },
    resetCreateLoading: (state, action) => {
      state.createLoading = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchTasks.pending, (state, action) => {
        state.data = [];
        state.allFilteredTasks = [];
        state.loading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      fetchTasks.fulfilled, (state, { payload  }) => {
        // Store all filtered tasks
        state.allFilteredTasks = payload.tasks;
        
        // Calculate pagination based on filtered tasks
        const filteredTotal = payload.tasks.length;
        const totalPages = Math.ceil(filteredTotal / state.pageSize) || 1;
        
        // Ensure page is within bounds
        if (state.page > totalPages && totalPages > 0) {
          state.page = totalPages;
        }
        
        // Apply client-side pagination
        const startIndex = (state.page - 1) * state.pageSize;
        const endIndex = startIndex + state.pageSize;
        state.data = payload.tasks.slice(startIndex, endIndex);
        
        state.pages = totalPages;
        state.totalValues = filteredTotal || 1;
        state.loading = "loaded";
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      fetchTasks.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.loading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      fetchTaskAttachments.pending, (state, action) => {
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      fetchTaskAttachments.fulfilled, (state, { payload  }) => {
        state.attachments = payload.filter(({ data: { fileName }}) => fileName.match(/\.png|\.jpg$|\.jpeg$/i));
        state.files = payload.filter(({ data: { fileName }}) => fileName.match(/\.pdf/i));
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      fetchTaskAttachments.rejected,(state, action) => {
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      fetchTask.pending, (state, action) => {
        state.task = false;
        state.loading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      fetchTask.fulfilled, (state, { payload  }) => {
        state.task = payload;
        state.loading = "loaded";
        state.currentRequestId = undefined;
        // Merge updated single task into the list if present to avoid stale UI while list refetch lags
        if (Array.isArray(state.data) && state.data.length > 0 && payload && payload.id) {
          const index = state.data.findIndex((t) => t.id === payload.id);
          if (index !== -1) {
            state.data[index] = payload;
          }
        }
      }
    );
    builder.addCase(
      fetchTask.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.loading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      fetchTaskNotes.pending, (state, action) => {
        state.notes = false;
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      fetchTaskNotes.fulfilled, (state, { payload  }) => {
        state.notes = payload.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      fetchTaskNotes.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.loading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      addTaskNote.pending, (state, action) => {
        state.notesLoading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      addTaskNote.fulfilled, (state, { payload  }) => {
        state.notesLoading = false;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      addTaskNote.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.notesLoading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      createTaskAttachment.pending, (state, action) => {
        state.attachmentLoading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      createTaskAttachment.fulfilled, (state, { payload }) => {
        state.attachmentLoading = false;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      createTaskAttachment.rejected,(state, action) => {
        state.attachmentLoading = "error";
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      createTask.pending, (state, action) => {
        state.createLoading = "loading";
      }
    );
    builder.addCase(
      createTask.fulfilled, (state, { payload }) => {
        state.createLoading = false;
      }
    );
    builder.addCase(
      createTask.rejected,(state, action) => {
        state.createLoading = false;
        state.error = action.error.message;
      }
    );
  }
})

// Action creators are generated for each case reducer function
export const {
  clear,
  resetAttachmentLoading,
  setAttachmentLoading,
  resetCreateLoading,
  setPage,
  setPageSize,
  setOwnerFilter,
  setOrder,
  selectTask,
  setSearch,
  setFilters,
  setTask,
} = taskSlice.actions

export default taskSlice.reducer
